/**
 * Plugin Vue qui branche le tracking V0 sur le router :
 *  - `Page Viewed` à chaque navigation `afterEach` (post-auth uniquement)
 *
 * Doit être installé APRÈS `routerPlugin` (le router doit exister) et APRÈS
 * `createPinia()` (auth.store accessible via track()).
 *
 * Cf. `loadApp.ts` (installRouter helper) et `top/docs/projects/tracking-product-plan-v1.md`.
 */

import type { App } from "vue"
import router from "./router.plugin"
import { track } from "@core/tracking/track"
import { deriveModuleFromRoute } from "@core/tracking/router-module-map"

export default {
    install(_app: App) {
        // État local au plugin (capturé dans la closure du afterEach)
        let lastNavigationTimestamp = Date.now()
        let lastRoute: string | null = null

        router.afterEach((to) => {
            const now = Date.now()
            const timeInPreviousRouteSeconds =
                lastRoute !== null
                    ? Math.round((now - lastNavigationTimestamp) / 1000)
                    : undefined

            // Skip routes publiques (login, demande/*, etc.) — V0 ne track que les
            // sessions authentifiées. Le filtre côté track() ne suffit pas car on
            // veut éviter de polluer même la phase pré-auth.
            const requiresAuth = to.matched.some(
                (record) => record.meta?.requiresAuth
            )
            if (!requiresAuth) {
                lastNavigationTimestamp = now
                lastRoute = to.path
                return
            }

            track({
                event: "Page Viewed",
                payload: {
                    route: to.path,
                    module: deriveModuleFromRoute(to.path),
                    previous_route: lastRoute ?? undefined,
                    time_in_previous_route_seconds: timeInPreviousRouteSeconds,
                },
            })

            lastNavigationTimestamp = now
            lastRoute = to.path
        })
    },
}
